import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ConfigurationContext from 'UserRegistration/contexts/ConfigurationContext';
import PublicPackageSelector from 'UserRegistration/components/RegistrationSteps/PackageSelector/PublicPackageSelector';
import AddContactPackageSelector from 'UserRegistration/components/RegistrationSteps/PackageSelector/AddContactPackageSelector';

/**
 * Displays the Add Contact version of the Billing Information section.
 * 
 * @param {object} props 
 */
function PackageSelector(props) {

    const { componentConfig } = useContext(ConfigurationContext);

    const renderPackageSelectorAccordingToContext = () => {

        switch(componentConfig.context) {
            case 'ADD_CONTACT':
                return ( <AddContactPackageSelector {...props} />);
            case 'PUBLIC_REGISTRATION':
                return ( <PublicPackageSelector {...props} />);
            default:
                return ( null );
        }
    }

    return renderPackageSelectorAccordingToContext();

}

PackageSelector.propTypes = {
    /** Flag that indicates whether or not packages without a cost should be displayed. */
    displayFreePackages: PropTypes.bool,
    /** A key that corresponds to a property of the registrationModel object. @see UserRegistration.js */
    modelKey: PropTypes.string,
    /** The ID of the package group to preselect. */
    preselectedGroupId: PropTypes.number,
    /** List of preselected subscription item IDs to preselect (nullable)*/
    preselectedSubscriptionItemId: PropTypes.array,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number,
    /** The frequency that the pckage selector should default to when it first loads. */
    defaultFrequency: PropTypes.string,
    /** The promotional code. */
    promoCode: PropTypes.string
};

export default PackageSelector;
